// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login Page Styles */
.login-container {
  display: flex;
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Left Panel - Orange Background */
.left-panel {
  flex: 2 1;
  background: #DF6E1C;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 40px 40px;
  background-position: 0 0, 20px 20px;
  margin: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.left-content {
  max-width: 796px;
  color: white;
}

/* Logo in Left Panel */
.logo-container {
  margin-bottom: 25px;
}

.welcome-content {
  width: 557px;
}

/* Welcome Content */
.welcome-title {
  font-size: 38px;
  font-weight: 600;
  line-height: 48px;
  margin-bottom: 24px;
  text-align: left;
}

.welcome-description {
  font-size: 16px;
  line-height: 26px;
  font-weight: 500;
  opacity: 0.95;
  text-align: left;
}

/* Right Panel - Login Form */
.right-panel {
  flex: 1 1;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 50px 30px 0;
  /* padding: 40px; */
}

.form-container {
  width: 100%;
  max-width: 400px;
}

/* Form Logo */
.form-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 48px;
}

.form-logo-main {
  background: #E8803B;
  color: white;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px 0 0 6px;
}

.form-logo-sub {
  background: #3B82F6;
  color: white;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 0 6px 6px 0;
}

/* Form Header */
.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-title {
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
  color: #000A14;
  margin-bottom: 8px;
}

.form-subtitle {
  font-size: 18px;
  line-height: 30px;
  font-weight: 400;
  color: #545B62;
  margin: 0;
}

/* Login Form */
.login-form {
  width: 100%;
}

/* Error Message */
.error-message {
  background: #FEF2F2;
  border: 1px solid #FECACA;
  color: #DC2626;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 24px;
  text-align: center;
}

.form-group {
  margin-bottom: 24px;
}

/* Form Row - for side-by-side fields */
.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.form-row .form-group {
  flex: 1 1;
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 16px;
  color: #1F2937;
  background: white;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #E8803B;
  box-shadow: 0 0 0 3px rgba(232, 128, 59, 0.1);
}

.form-input:disabled {
  background-color: #F9FAFB;
  color: #9CA3AF;
  cursor: not-allowed;
}

.form-input::placeholder {
  color: #9CA3AF;
}

/* Password Input Container */
.password-input-container {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6B7280;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.password-toggle:hover:not(:disabled) {
  color: #E8803B;
  background-color: #FEF3F0;
}

.password-toggle:disabled {
  color: #9CA3AF;
  cursor: not-allowed;
}

/* Login Button */
.login-button {
  width: 100%;
  height: 38px;
  background: #E8803B;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.login-button:hover:not(:disabled) {
  background: #D9732A;
  transform: translateY(-1px);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  background: #9CA3AF;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .login-container {
    flex-direction: column;
  }
  
  .left-panel {
    flex: 1 1;
    min-height: 40vh;
    border-radius: 0;
  }
  
  .right-panel {
    flex: 1 1;
    min-height: 60vh;
  }
  
  .left-content {
    padding: 40px;
    text-align: center;
  }
  
  .welcome-title {
    font-size: 28px;
  }
  
  .welcome-description {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .left-content {
    padding: 20px;
  }
  
  .welcome-title {
    font-size: 24px;
  }
  
  .welcome-description {
    font-size: 14px;
  }
  
  .form-container {
    padding: 0 20px;
  }
  
  .form-title {
    font-size: 24px;
  }
  
  .form-subtitle {
    font-size: 14px;
  }
  
  /* Stack form fields vertically on mobile */
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-row .form-group {
    margin-bottom: 24px;
  }
}

@media (max-width: 480px) {
  .right-panel {
    padding: 20px;
  }
  
  .logo-circle {
    width: 100px;
    height: 100px;
  }
  
  .logo-main {
    font-size: 16px;
  }
  
  .logo-sub {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,iBAAiB;EACjB,uKAAuK;AACzK;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,mBAAmB;EACnB;;qFAEmF;EACnF,0BAA0B;EAC1B,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Login Page Styles */\n.login-container {\n  display: flex;\n  min-height: 100vh;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Left Panel - Orange Background */\n.left-panel {\n  flex: 2;\n  background: #DF6E1C;\n  background-image: \n    radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 1px, transparent 1px),\n    radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.1) 1px, transparent 1px);\n  background-size: 40px 40px;\n  background-position: 0 0, 20px 20px;\n  margin: 30px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n}\n\n.left-content {\n  max-width: 796px;\n  color: white;\n}\n\n/* Logo in Left Panel */\n.logo-container {\n  margin-bottom: 25px;\n}\n\n.welcome-content {\n  width: 557px;\n}\n\n/* Welcome Content */\n.welcome-title {\n  font-size: 38px;\n  font-weight: 600;\n  line-height: 48px;\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.welcome-description {\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 500;\n  opacity: 0.95;\n  text-align: left;\n}\n\n/* Right Panel - Login Form */\n.right-panel {\n  flex: 1;\n  background: #FFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 30px 50px 30px 0;\n  /* padding: 40px; */\n}\n\n.form-container {\n  width: 100%;\n  max-width: 400px;\n}\n\n/* Form Logo */\n.form-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 48px;\n}\n\n.form-logo-main {\n  background: #E8803B;\n  color: white;\n  padding: 8px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 6px 0 0 6px;\n}\n\n.form-logo-sub {\n  background: #3B82F6;\n  color: white;\n  padding: 8px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 0 6px 6px 0;\n}\n\n/* Form Header */\n.form-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.form-title {\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n  color: #000A14;\n  margin-bottom: 8px;\n}\n\n.form-subtitle {\n  font-size: 18px;\n  line-height: 30px;\n  font-weight: 400;\n  color: #545B62;\n  margin: 0;\n}\n\n/* Login Form */\n.login-form {\n  width: 100%;\n}\n\n/* Error Message */\n.error-message {\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  color: #DC2626;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n/* Form Row - for side-by-side fields */\n.form-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.form-row .form-group {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  font-size: 16px;\n  color: #1F2937;\n  background: white;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #E8803B;\n  box-shadow: 0 0 0 3px rgba(232, 128, 59, 0.1);\n}\n\n.form-input:disabled {\n  background-color: #F9FAFB;\n  color: #9CA3AF;\n  cursor: not-allowed;\n}\n\n.form-input::placeholder {\n  color: #9CA3AF;\n}\n\n/* Password Input Container */\n.password-input-container {\n  position: relative;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #6B7280;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.password-toggle:hover:not(:disabled) {\n  color: #E8803B;\n  background-color: #FEF3F0;\n}\n\n.password-toggle:disabled {\n  color: #9CA3AF;\n  cursor: not-allowed;\n}\n\n/* Login Button */\n.login-button {\n  width: 100%;\n  height: 38px;\n  background: #E8803B;\n  color: white;\n  border: none;\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.login-button:hover:not(:disabled) {\n  background: #D9732A;\n  transform: translateY(-1px);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  background: #9CA3AF;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .login-container {\n    flex-direction: column;\n  }\n  \n  .left-panel {\n    flex: 1;\n    min-height: 40vh;\n    border-radius: 0;\n  }\n  \n  .right-panel {\n    flex: 1;\n    min-height: 60vh;\n  }\n  \n  .left-content {\n    padding: 40px;\n    text-align: center;\n  }\n  \n  .welcome-title {\n    font-size: 28px;\n  }\n  \n  .welcome-description {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .left-content {\n    padding: 20px;\n  }\n  \n  .welcome-title {\n    font-size: 24px;\n  }\n  \n  .welcome-description {\n    font-size: 14px;\n  }\n  \n  .form-container {\n    padding: 0 20px;\n  }\n  \n  .form-title {\n    font-size: 24px;\n  }\n  \n  .form-subtitle {\n    font-size: 14px;\n  }\n  \n  /* Stack form fields vertically on mobile */\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .form-row .form-group {\n    margin-bottom: 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .right-panel {\n    padding: 20px;\n  }\n  \n  .logo-circle {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .logo-main {\n    font-size: 16px;\n  }\n  \n  .logo-sub {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
